<template>
	<div class="topcon">
		<div class="top_c">
			<div class="left_c">
				<div class="frame_c" :style="mintitle == '案例/课件'?'width: 270px;':''">
					<div>
						<span class="a_c">{{maxtitle}}</span>
						<span class="b_c">{{mintitle}}</span>
					</div>
					
					<img src="../static/img/bowimg@2x.png" alt=""/>
				</div>
			</div>
			<div class="right_c">
				<img src="../static/img/rightarrow@2x.png" alt="" @click="seemore"/>
			</div>
		</div>
		
	</div>
	
</template>

<script>


export default {
  props:['maxtitle','mintitle','pathUrl','sign',],
  
  data: function() {
    return {
      
	  
    };
  },
  
  mounted() {
	
  },

  methods: {
		seemore(){
			if(this.pathUrl){ 
				this.$router.push({path:this.pathUrl})
				return
			}
			if(this.sign == '1'){
				this.$router.push({ path: '/socialintell' });
			}else if(this.sign == '2'){
				this.$router.push({ path: '/learnmaterials' });
			}else if(this.sign == '3'){
				this.$router.push({ path: '/filelibrary' });
			}else if(this.sign == '4'||this.sign == '5'||this.sign == '6'||this.sign == '7'){
				this.$router.push({ path: '/downloadlist?signtype='+this.sign });
			}
			
			
		},
		
	  
  },
  
  
};
</script>

<style scoped="scoped" lang="scss">
	
.topcon{
	
	.top_c{
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		.left_c{
			.frame_c{
				width: 265px;
				height:71px;
				background: #FFFFFF;
				border: 1px solid #E61F26;
				border-radius: 36px;
				display: flex;
				align-items: center;
				justify-content: space-around;
				.a_c{
					margin-left: 20px;
					font-size: 38px;
					font-weight: 400;
					color: #FA9E1E;
				}
				.b_c{
					font-size:28px;
					font-weight: 400;
					color: #010101;
				}
				img{
					margin-right: 20px;
					height:69px;
					width:27px;
				}
			}			
		}
		
		.right_c{
			img{
				cursor: pointer;
				height: 20px;
				width: 107px;
			}
		}	
	}
	
	
	
}

</style>
